<div class="row reports-content poc mat-elevation-z1" style="height: 100%; display: flex; flex-direction: row; gap: 10px;">
    <mat-sidenav-container class="poc-container">
        <mat-sidenav mode="side" opened>
            <div class="sidenav-date-picker mt-4 pt-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Effective Date</mat-label>
                    <input matInput [matDatepicker]="picker" [value]="effectiveDate" (dateChange)="onDateChange($event)" [min]="minDate">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <mat-nav-list>
                <a mat-list-item routerLink="/common-items/items">
                    <img class="cfa-icon-white" ngSrc="assets/img/common-items/fork-and-knife.svg" alt="Fork and Knife Icon" height="18" width="18"/>
                    <span class="poc-mat-list-item">Common Items</span>
                </a>
            </mat-nav-list>
            <!-- TODO SM other buttons at bottom, e.g. History, Admin, Info, etc -->
        </mat-sidenav>

        <mat-sidenav-content>
            <div class="poc-router-scrollbar">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
